import { render, staticRenderFns } from "./onLineStudyDetail.vue?vue&type=template&id=5c5351c7&scoped=true"
import script from "./onLineStudyDetail.vue?vue&type=script&lang=js"
export * from "./onLineStudyDetail.vue?vue&type=script&lang=js"
import style0 from "./onLineStudyDetail.vue?vue&type=style&index=0&id=5c5351c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5351c7",
  null
  
)

export default component.exports